import { gqlClient } from '@/api/graphql-client';
import timelogKeys from '@/api/queries/timelog/keyFactor';
import { filterMatchesNoOne } from '@/api/queries/timelog/useGetTimelogs';
import { graphql } from '@/gql';
import { GetTimelogsInput, TimelogsByUserQuery } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';

// One paginated timelogs result per account user, scoped to that user by the
// User.timelogs field. We only need the totals here, so request a single item.
const TIMELOGS_BY_USER = graphql(`
  query TimelogsByUser(
    $input: GetTimelogsInput
    $pagination: PaginationInput!
  ) {
    me {
      user {
        account {
          users {
            id
            publicId
            fullName
            firstName
            lastName
            email
            colour
            avatarUrl
            timelogs(input: $input, pagination: $pagination) {
              totalCount
              totalDuration
              totalCost {
                value
                currency {
                  id
                  code
                  exponent
                }
              }
            }
          }
        }
      }
    }
  }
`);

export type TimelogUserTotal =
  TimelogsByUserQuery['me']['user']['account']['users'][0];

export const useGetTimelogsByUser = (input?: GetTimelogsInput) => {
  return useQuery({
    // Keyed under the timelogs prefix so an edit/delete invalidates it too.
    queryKey: [...timelogKeys.all, 'byUser', { input }],
    enabled: !filterMatchesNoOne(input),
    queryFn: () =>
      gqlClient.request(TIMELOGS_BY_USER, {
        input,
        pagination: { limit: 1, offset: 0 },
      }),
  });
};
